import PersonSearch from "assets/PersonSearch.svg";
import PersonSearch2 from "assets/PersonSearch2.svg";
import colors from "styles/Colors";
import { pageNames } from "utils/Types";

export const noPlansMessageCommon = {
  [pageNames.libraryHall]: {
    label: "Library Hall",
    title: "No plans are currently available - that's okay.",
    content: "Check and reset your filters for a different selection.",
    showButton: false,
    backgroundColor: colors.Neutral.Neutral400,
    image: PersonSearch2
  },
  [pageNames.allPlans]: {
    label: "All Plans",
    title: "No plans are currently available - that's okay.",
    content: "Check and reset your filters for a different selection.",
    showButton: false,
    backgroundColor: colors.Neutral.Neutral400,
    image: PersonSearch2
  },
  [pageNames.functionalArea]: {
    label: "All Plans",
    title: "There are no plans for this Functional Areas.",
    content: "We are always adding the most relevant content for you -continue to check back or retake the Wizard.",
    showButton: false,
    backgroundColor: colors.Neutral.Neutral400,
    image: PersonSearch2
  },
  [pageNames.searchResult]: {
    label: "All Plans",
    title: "There are no plans for this search.",
    content: "We are always adding the most relevant content for you -continue to check back or retake the Wizard.",
    showButton: false,
    backgroundColor: colors.Neutral.Neutral400,
    image: PersonSearch2
  },
  [pageNames.bookmarked]: {
    label: "Bookmarked",
    title: "You have no bookmarked plans. No problem!",
    content: "If you are ready for your next step, go search the Library.",
    showButton: true,
    buttonLabel: "Explore Library",
    backgroundColor: colors.Blue.Blue300,
    image: PersonSearch
  }
};
